import { useEffect } from "react";

export default function GTM() {
  useEffect(() => {
    const GTM_ID = "GTM-5K8G368M";

    // evita duplicar (React StrictMode / hot reload)
    if (window.__GTM_LOADED__) return;
    window.__GTM_LOADED__ = true;

    // garante dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    // injeta o script do GTM no <head>
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(script);
  }, []);

  return null;
}
